import React, { memo, useState } from 'react';
import { isSet } from '../../../../Utils/CommonFunctions';
import convertToHtml from '../../../../Components/FormBuilder/Builder/FormInputs/convertDraftjsToHtml';
import  '../../custom.css';
import { getUserInfo } from '../../../../Utils/UserFunctions';
import Icons from '../../../../Components/Icons/Icons';


const SubFormHead = ({ section, validationForms, keyIndex, tHeadClassName, subFormSorting, isVirtualized, ...props }) => {
    let sectionData = section.data;
    const [sortColumn, setSortColumn] = useState({})
    const userInfo = getUserInfo();
    if (userInfo?.data?.role_name === 'Community Partners') {
    sectionData = section.data.filter(
        (item) => item.api_custom_field_name !== "cf_quoted_cost"
    );
    }
    const sortSubform = (item) => {

        if(props.pageType==='form') return;
        const colKey = item.api_custom_field_name;
        const currentDirection = sortColumn[colKey];
        const newDirection = currentDirection === 'asc' ? 'desc' : 'asc';
        const newSortObject = { [colKey]: newDirection };
        setSortColumn(newSortObject);

        subFormSorting(item, colKey, newDirection === 'asc');
    }
    const stickyHeaderStyle = isVirtualized
      ? { position: 'sticky', top: 0, zIndex: 12, backgroundColor: (props.pageType === 'form') ? '#fff' : undefined }
      : {};
    const firstColStyle = {
      width: '30px',
      position: 'sticky',
      left: 0,
      backgroundColor: (props.pageType === 'form') ? 'white' : ' ',
      zIndex: isVirtualized ? 13 : 11,
      ...(isVirtualized ? { top: 0 } : {}),
    };
    return (
        <thead className={tHeadClassName}>
            <tr key={keyIndex}>
                {isSet(props.isWrite,true)===true && 
                    <th style={firstColStyle} className='fixed-first-col'>
                     {(props.pageType==='form' && props.sectionSubformData.subform_rows.length>1) && <input type='checkbox' checked={props.isSelectAll} onClick={(e)=>props.selectAll(e.target.checked)}></input>}
                    </th>
                }
                {sectionData.map((item, index) => {
               
                    const isHidden = isSet(item.access_mode, 'EDITABLE') === 'HIDDEN';
                    const isVisibleColumn = props.pageType === 'view'
                        ? isSet(item.is_detail_view, true) !== false
                        : isSet(item.is_add_form, false) === true;

                    if (isHidden || !isVisibleColumn) return null;

                    return (
                        <th key={'head_' + index} onClick={() => sortSubform(item)} className= {props.pageType==='form' ? "" : 'cursor-pointer'} style={stickyHeaderStyle}>
                            <span>{convertToHtml(item.label)}</span>
                                <span
                                    className="mt-1 mr-2"
                                    style={{ visibility: sortColumn[item.api_custom_field_name] ? "visible" : "hidden" }}
                                >
                                  {props.pageType==='form' ? " " :  <Icons iconType="TableSort" type={sortColumn[item.api_custom_field_name]}/> }
                                </span>
                            {validationForms[item.id] ? (
                                <div>
                                    <span className="text-danger m-1">{validationForms[item.id]}</span>
                                </div>
                            ) : null}
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
};

// Default props
SubFormHead.defaultProps = {
    tHeadClassName: '',
};

export default memo(SubFormHead);